import { collectionService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {},
    myCollections: {},
    featured: {},
    loading: false,
    selectList: {}
  }
}

export const collections = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllCollections({ commit }, params) {
      commit('getAllCollectionsRequest');
      collectionService.getAll(params)
      .then(
          collections => commit('getAllCollectionsSuccess', collections),
          error => commit('getAllCollectionsFailure', error)
      );
    },
    getSelectList({ commit }) {
      commit('getSelectListRequest');
      collectionService.getSelectList()
      .then(
          operators => commit('getSelectListSuccess', operators),
          error => commit('getSelectListFailure', error)
      );
    },
    getMyCollections({ commit }, params) {
      commit('getMyCollectionsRequest');
      collectionService.getMyCollections(params)
      .then(
          collections => commit('getMyCollectionsSuccess', collections),
          error => commit('getMyCollectionsFailure', error)
      );
    },
    searchCollections({ commit }, qry) {
      commit('getAllCollectionsRequest');
      collectionService.searchCollections(qry)
      .then(
          collections => commit('getAllCollectionsSuccess', collections),
          error => commit('getAllCollectionsFailure', error)
      );
    },
    getById({ commit }, id) {
      commit('getByIdRequest');
      collectionService.getById(id)
      .then(
        response => {
          commit('getByIdSuccess', response);
          return response;
        },
          error => {
            commit('getByIdFailure', error)
          return error;
          }
      );
    },
    addCollection({ commit }, payload){
      commit('addCollectionRequest');
      collectionService.addCollection(payload)
      .then(
        collections => commit('addCollectionSuccess', collections),
        error => commit('addCollectionFailure', error)
      )

      collectionService.getAll()
      .then(
          collections => commit('getAllCollectionsSuccess', collections),
          error => commit('getAllCollectionsFailure', error)
      );
    },
    updateCollection({ commit }, payload){
      commit('updateCollectionRequest');
      collectionService.updateCollection(payload)
      .then(
        collections => commit('updateCollectionSuccess', collections),
        error => commit('updateCollectionsFailure', error)
      )
    },
    deleteCollection({ commit }, payload){
      //commit('updateCollectionRequest');
      collectionService.deleteCollection(payload)
      .then(
        collections => commit('updateCollectionSuccess', collections),
        error => commit('updateCollectionsFailure', error)
      )
    },
    addRecipeToCollection({ commit }, payload){
      return collectionService.addRecipeToCollection(payload)
    },
    removeRecipeFromCollection({ commit }, recipePayload){
      return collectionService.removeRecipeFromCollection(recipePayload)
    },
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllCollectionsRequest(state) {
        state.loading = 'loading'
    },
    getAllCollectionsSuccess(state, collections) {
        state.loading = false
        state.all = collections;
    },
    getAllCollectionsFailure(state, error) {
        state.all = { error };
        state.loading = false
    },
    getSelectListRequest(state) {
        state.selectList = { loading: true };
    },
    getSelectListSuccess(state, collections) {
        state.selectList = Object.values(collections || {});
    },
    getSelectListFailure(state, error) {
        state.selectList = { error };
    },
    getMyCollectionsRequest(state) {
        state.loading = 'loading'
    },
    getMyCollectionsSuccess(state, collections) {
        state.loading = false
        state.myCollections = collections;
    },
    getMyCollectionsFailure(state, error) {
        state.myCollections = { error };
        state.loading = false
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, collection) {
      state.current = collection;
      return collection;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addCollectionRequest(state, collection) {
      state.current = collection;
      state.loading = 'Loading';
    },
    addCollectionSuccess(state, collection) {
      state.current = collection;
      state.loading = 'Saved';
    },
    addCollectionFailure(state, error) {
      state.update = { error };
    },
    updateCollectionRequest(state, collection) {
      state.current = collection;
      state.loading = 'Loading';
    },
    updateCollectionSuccess(state, collection) {
        state.current = collection;
        state.loading = 'Saved';
    },
    updateCollectionFailure(state, error) {
      state.update = { error };
    }
  }
}